// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1PDY6","col":"styles_col__1UOCS","fulfillmentStatus":"styles_fulfillmentStatus__10-hF","emailCol":"styles_emailCol__1drgD"};